import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class EntityDetailsService {

  constructor(private http: HttpClient) { }

  // Get 8858 entities with search
  get8858Entities(
    baseUrl: string,
    searchParams: any = {},
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build params exactly like AngularJS service
    let params = (filterParams && Object.keys(filterParams).length > 0) ? 
      _.extend({}, filterParams) : {};
    params = _.extend({}, searchParams, params);

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const url = `${baseUrl}/loadJsonObject?action_code=drhn7z`;
    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // Get GILTI Consol Group Key
  getGiltiCGK(
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build params exactly like AngularJS service
    let params = (filterParams && Object.keys(filterParams).length > 0) ? 
      _.extend({}, filterParams) : {};

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const url = `${baseUrl}/loadJsonObject?action_code=00ya1v`;
    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // Update entity details
  updateEntityDetails(
    baseUrl: string,
    entityData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    userSettings: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=kxmkf2`;

    // 🚀 CRITICAL: Build payload exactly as specified
    // Merge globalParams and filterParams
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);

    // Extract values with fallbacks
    const taxYear = filterParams?.tax_year || globalService?.tax_year || '';
    const screenKey = filterParams?.screen_key || globalService?.screen_key || '';
    const scenario = filterParams?.scenario || globalService?.scenario || '';
    const jcdKey = filterParams?.jcd_key || globalService?.jcd_key || '';
    const jcdTaKey = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '';
    const activityKey = filterParams?.activity_key || globalService?.activity_key || '';
    const screenType = filterParams?.screen_type || globalService?.screen_type || 'grid';
    const isLocked = filterParams?.is_locked || globalService?.is_locked || 'N';
    const issueId = filterParams?.issue_id || globalService?.issue_id || '';
    const issueShortDesc = filterParams?.issue_short_desc || globalService?.issue_short_desc || '';
    const issueIdForTxSave = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '';
    const scenarioCode = filterParams?.scenarioCode || globalService?.scenarioCode || 'RAF';
    const isIssueKeyEnabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    const ssoId = userSettings?.user?.sso_id || globalService?.sso_id || '';

    // Build checkLockedbj from rowData
    const checkLockedbj = [{
      leid: rowData.LEID || '',
      me_code: rowData.ME_CODE || globalService?.me_code || '',
      cdr_number: rowData.CDR_NO || rowData.CDR_NUMBER || '',
      consol_group_key: rowData.CONSOL_GROUP_KEY || 1,
      reporting_period: rowData.REPORTING_PERIOD || 1,
      combination_key: rowData.COMBINATION_KEY || rowData.combination_key || 0,
      scenario_key: parseInt(scenario) || 74
    }];

    // Build jsonSettings
    const jsonSettings: any = {
      tax_year: taxYear,
      scenario: parseInt(scenario) || 74,
      filing_key: rowData.CONSOL_GROUP_KEY || rowData.FILING_KEY || 1,
      system: filterParams?.system || globalService?.system || 'A',
      filter_by: filterParams?.filter_by || globalService?.filter_by || '',
      parent_me_string: filterParams?.parent_me_string || globalService?.parent_me_string || '',
      jcd_key: jcdKey
    };

    // Build final params object
    params = {
      tax_year: taxYear,
      screen_key: screenKey,
      scenario: scenario,
      jcd_key: jcdKey,
      jcd_ta_key: jcdTaKey,
      activity_key: activityKey,
      screen_type: screenType,
      is_locked: isLocked,
      issue_id: issueId,
      issue_short_desc: issueShortDesc,
      issue_id_for_tx_save: issueIdForTxSave,
      checkLockedbj: JSON.stringify(checkLockedbj),
      scenarioCode: scenarioCode,
      is_issue_key_enabled: isIssueKeyEnabled,
      sso_id: ssoId,
      process_name: 'SAVE_ENTITY_DETAILS_8858_FILER_CLASS',
      jsonSettings: JSON.stringify(jsonSettings),
      jsonObj: JSON.stringify(entityData)
    };

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

